module.exports = __webpack_public_path__ + "static/media/dry-cleaning.6a5bef2e.webp";